import imgDefault from "../../../../img/questionMark.png"
import I18n from "../../../i18n";
import { IImage, TArrayAnswer } from "../../../interfaces/quiz";
import alternativeBuilder from "./alternative";

export default function question(theme:string,question:string,answer:TArrayAnswer,image:IImage):string{
    let alternatives="";
    answer.forEach((alternative,index)=>{
        alternatives += alternativeBuilder(index,alternative);
    })
    return `
        <div id="quiz-play">
            <h3 class="quiz-theme">${I18n.apply("Tema")}:${theme}</h3>
            <h3 class="quiz-feedback"></h3>
            <div class="quiz-container">
                <h4 class="quiz-question">
                    ${question}
                </h4>
                <div class="answer-container">
                    <img src="${image.exist?image.src:imgDefault}" alt="question-img">
                    <div class="answer-options">
                        ${alternatives}
                    </div>
                </div>
            </div>
            <button type="button" class="btn-back">${I18n.apply("sair")}</button>
        </div>
    `;
}